exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-left-status[data-v-e8448518] {\n  margin-right: 5px;\n}\n.content-line[data-v-e8448518] {\n  padding: 12px;\n  margin-bottom: 5px;\n  border-radius: 5px;\n}\n.content-line-1[data-v-e8448518] {\n  padding: 6px;\n  margin-bottom: 5px;\n  border-radius: 5px;\n}\n.color-1[data-v-e8448518] {\n  background: #c694f9;\n}\n.color-2[data-v-e8448518] {\n  background: #6aa5e3;\n}\n.color-3[data-v-e8448518] {\n  background: #feb683;\n}\n.color-4[data-v-e8448518] {\n  background: #ef5b5b;\n}\n.album-date[data-v-e8448518] {\n  margin-top: 25px;\n}\n", ""]);

// exports
